import { calculateStageScore } from './calculateScores';
import { getCurrentProblem, getCurrentPossibleProblem } from './getCurrentProblem';
import getStatusTimeForStage from './getStatusTimeForStage';

const STAGES_MAP = { ONROUTE: 'ONROUTE', PENDING: 'PENDING', DONE: 'DONE' };
const STAGES = Object.values(STAGES_MAP);

const getStage = (stage, { stop = {} }) => {
  const { score, problems, shipment_state_logs, stop_type } = stop;

  const stageScore = calculateStageScore(stage);
  const timeDone = getStatusTimeForStage(stage, stop_type, shipment_state_logs);

  const currentProblem = getCurrentProblem(stage, problems, { score, stageScore });
  const currentPossibleProblems = getCurrentPossibleProblem(stage, problems, { score, stageScore });

  return {
    score: stageScore,
    timeDone,
    warning: currentProblem,
    possibleWarning: currentPossibleProblems,
  };
};

const getTimeDone = (stage, { shipment_state_logs, stop_type }) => {
  return getStatusTimeForStage(stage, stop_type, shipment_state_logs);
};

const getStopStatusLog = (stage, stop) => {
  if (!STAGES.includes(stage)) {
    return;
  }

  return getStage(stage, { stop });
};

export { STAGES_MAP, STAGES, getStopStatusLog, getTimeDone };
